import React from 'react'
import PropTypes from 'prop-types'
import Button from '../../../Button'
import styles from '../styles'

export default function PlayerPlusBanner({ usedTrial, bannerData, imageView }) {
  const backgroundWeb = bannerData?.Background?.data
    ? bannerData?.Background?.data[0]?.attributes?.url
    : null
  const backgroundMobile = bannerData?.Background?.data
    ? bannerData?.Background?.data[1]?.attributes?.url
    : null
  const data = {
    backgroundWeb,
    backgroundMobile,
    backgroundAlt: bannerData?.Background?.data?.attributes?.alternativeText,
    logo: bannerData?.Logo?.data?.attributes?.url,
    logoAlt: bannerData?.Logo?.data?.attributes?.alternativeText,
    textImage: bannerData?.TextImage?.data?.attributes?.url,
    textImageAlt: bannerData?.TextImage?.data?.attributes?.alternativeText,
    stackedTextImage: bannerData?.StackedTextImage?.data?.attributes?.url,
    stackedTextImageAlt: bannerData?.StackedTextImage?.data?.attributes?.alternativeText,
    buttonLink: bannerData?.ButtonLink,
    buttonText: bannerData?.ButtonText,
    plusExtraButtonLink: bannerData?.PlusExtraButtonLink,
    plusExtraButtonText: bannerData?.PlusExtraButtonText,
    borderColor: bannerData?.BorderColor,
  }
  const href = usedTrial ? data?.buttonLink : data?.plusExtraButtonLink
  const text = usedTrial ? data?.buttonText : data?.plusExtraButtonText

  return (
    <div className="outerContainer" style={{ borderImageSlice: 1, borderImageSource: `linear-gradient(to left, ${data.borderColor})` }}>
      <div className="PlayerPlusBanner info-bannerPlayerPlus" style={imageView ? { backgroundImage: `url(${data.backgroundMobile})` } : { backgroundImage: `url(${data.backgroundWeb})` }}>
        <div className="banner-content">
          {imageView
            ? (
              <React.Fragment>
                <img
                  className="mobileImage"
                  src={data.stackedTextImage}
                  alt={data.stackedTextImageAlt}
                />
                <div className="mobileView">
                  <img
                    src={data.logo}
                    className="logoPlayerPlus"
                    alt={data.logoAlt}
                  />
                  <div className="button">
                    <Button
                      id="plus-banner-button"
                      variant="secondary"
                      style={{ minWidth: '150px' }}
                      href={href}
                      text={text || 'STV Player'}
                    />
                  </div>
                </div>
              </React.Fragment>
            )
            : (
              <React.Fragment>
                <img
                  src={data.logo}
                  className="logoPlayerPlus"
                  alt={data.logoAlt}
                />

                <img
                  className="webImage"
                  src={data.textImage}
                  alt={data.textImageAlt}
                />

                <div className="button">
                  <Button
                    id="plus-banner-button"
                    variant="secondary"
                    href={href}
                    text={text || 'STV Player'}
                  />
                </div>
              </React.Fragment>
            )}
        </div>
      </div>
      <style jsx>{styles}</style>
    </div>
  )
}

PlayerPlusBanner.propTypes = {
  usedTrial: PropTypes.bool.isRequired,
  bannerData: PropTypes.shape({
    Background: PropTypes.object,
    backgroundAlt: PropTypes.string,
    Logo: PropTypes.object,
    logoAlt: PropTypes.string,
    TextImage: PropTypes.object,
    textImageAlt: PropTypes.string,
    StackedTextImage: PropTypes.object,
    stackedTextImageAlt: PropTypes.string,
    ButtonLink: PropTypes.string,
    ButtonText: PropTypes.string,
    PlusExtraButtonLink: PropTypes.string,
    PlusExtraButtonText: PropTypes.string,
    BorderColor: PropTypes.string,
  }),
  imageView: PropTypes.bool.isRequired,
}

PlayerPlusBanner.defaultProps = {
  bannerData: {
    background: '',
    backgroundAlt: '',
    logo: '',
    logoAlt: '',
    textImage: '',
    textImageAlt: '',
    stackedTextImage: '',
    stackedTextImageAlt: '',
    buttonLink: '',
    buttonText: '',
    plusExtraButtonLink: '',
    plusExtraButtonText: '',
  },
}
